import axios from 'axios'
import helper from '../helper'

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL

export const serviceConfirmProduct = {
  get: (token, params) => helper.get('api/v1/products-admin?pending=true', token, params),
  accepted: (token, { productId, pending }) => helper.patch('api/v1/products-admin/' + productId, { pending }, token),
  log: (token, params) => helper.get('api/v1/log-activities', token),
  delete: (token, { productId }) =>
    axios.delete(apiBaseUrl + `api/v1/products-admin/${productId}`, {
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).catch(err => err.response)
}
